module.exports = __webpack_public_path__ + "img/circle3.5bbc9115.png";